import { render } from "./ProjectsView.vue?vue&type=template&id=d3c7b0fc&scoped=true&ts=true"
import script from "./ProjectsView.vue?vue&type=script&lang=ts"
export * from "./ProjectsView.vue?vue&type=script&lang=ts"

import "./ProjectsView.vue?vue&type=style&index=0&id=d3c7b0fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3c7b0fc"]])

export default __exports__